import styled from "@emotion/styled";
import myThemes from "../../themes/Themes";
import { Link } from "@mui/material";
export const StyledTitle = styled("div")(({ theme }) => ({
  width: "100%",
  fontFamily: "Noto Serif",
  fontWeight: 700,
  fontSize: "25px",
  color: myThemes[theme].palette.primary,
  marginBottom: "2vh",
  display: "flex",
  alignItems: "center",
}));

export const StyledH1 = styled("h1")(({ theme }) => ({
  width: "100%",
  fontFamily: "Inter",
  color: myThemes[theme].palette.primary,
  paddingBottom: "15px",
  fontWeight: "600",
}));

export const StyledH2 = styled("h2")(({ theme }) => ({
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%",
  fontFamily: "Inter",
  color: myThemes[theme].palette.primary,
  paddingBottom: "5px",
  paddingTop: "10px",
  fontWeight: "600",
}));

export const StyledH3 = styled("h3")(({ theme }) => ({
  marginTop: 10,
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%",
  fontFamily: "Inter",
  color: myThemes[theme].palette.secondary,
}));

export const StyledH4 = styled("h4")(({ theme }) => ({
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%",
  fontFamily: "Inter",
  color: myThemes[theme].palette.secondary,
  paddingRight: "10px",
  marginTop: 7,
  marginBottom: 7,
}));

export const StyledH5 = styled("h5")(({ theme }) => ({
  display: "inline-block",
  verticalAlign: "middle",
  width: "100%",
  fontFamily: "Inter",
  color: myThemes[theme].palette.secondary,
  paddingRight: "10px",
  marginTop: 7,
  marginBottom: 7,
}));

export const StyledLink = styled(Link)(({ fireAnimation, theme, color }) => ({
  fontFamily: "Inter",
  color: color ? color : myThemes[theme].palette.secondary,
  fontSize: "13px",
  display: "flex",
  cursor: "pointer",
  textDecoration: "none",
  alignItems: "center",
  paddingBottom: fireAnimation ? "0px" : "10px",
  "&:hover": {
    textDecoration: "underline",
  },
  "#backIcon": {
    fontSize: "23px",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
}));

export const StyledText = styled("div")(
  ({
    fontSize,
    fontWeight,
    border,
    borderRadius,
    isPill,
    theme,
    display,
    width,
  }) => ({
    display: display ? display : "inline",
    maxWidth: "35vw",
    width: width ? width : "20px",

    fontFamily: "Inter",
    color: isPill
      ? myThemes[theme].palette.secondary
      : myThemes[theme].palette.primary,
    fontWeight: fontWeight ? fontWeight : "none",
    fontSize: fontSize,
    textDecoration: "none",
    alignItems: "center",
    textOverflow: "ellipsis",
    overflow: "hidden",
    border: border ? border : "none",
    backgroundColor: isPill ? myThemes[theme].palette.primary : null,
    paddingLeft: isPill ? "10px" : "none",
    paddingRight: isPill ? "10px" : "none",
    paddingTop: isPill ? "2px" : "none",
    paddingBottom: isPill ? "2px" : "none",
    borderRadius: isPill ? "50px" : "none",
  })
);

export const H4 = styled("h4")(({ theme }) => ({
  display: "block",
  fontFamily: "Inter",
  color: myThemes[theme].palette.secondary,
}));
